import { Fn2 }	from "ts-base/fn";

export type Semigroup<T>	= Readonly<{
	concat:	Fn2<T, T, T>,
}>;

export namespace Semigroup {
	export const fromFunction	= <T>(func:Fn2<T, T, T>):Semigroup<T>	=> ({
		concat:	func,
	});
}
